export default function getDueDate(date) {
  const dueDate = new Date(date);
  dueDate.setMonth(dueDate.getMonth() + 1, 1);
  dueDate.setHours(12, 0, 0);
  return dueDate;
}
